import { render, staticRenderFns } from "./TextareaTooltip.vue?vue&type=template&id=62dd9e43&scoped=true&"
import script from "./TextareaTooltip.vue?vue&type=script&lang=ts&"
export * from "./TextareaTooltip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62dd9e43",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTextarea,VTooltip})
